function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.12,
  x: 2,
  y: 2,
  width: 20,
  height: 20,
  rx: 6,
  stroke: "none"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 1v3m8-3v3m1.5 4h-11M8 12.5a.5.5 0 01-1 0m1 0a.5.5 0 00-1 0m1 0H7m1 4a.5.5 0 01-1 0m1 0a.5.5 0 00-1 0m1 0H7m5.5-4a.5.5 0 01-1 0m1 0a.5.5 0 00-1 0m1 0h-1m1 4a.5.5 0 01-1 0m1 0a.5.5 0 00-1 0m1 0h-1m5.5-4a.5.5 0 01-1 0m1 0a.5.5 0 00-1 0m1 0h-1m1 4a.5.5 0 01-1 0m1 0a.5.5 0 00-1 0m1 0h-1M8.4 22h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 001.748-1.748C22 18.96 22 17.84 22 15.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 00-1.748-1.748C18.96 2 17.84 2 15.6 2H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 00-1.748 1.748C2 5.04 2 6.16 2 8.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 001.748 1.748C5.04 22 6.16 22 8.4 22z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
});

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    stroke: "#D8DAE7",
    fill: "#D8DAE7"
  }, props), _ref, _ref2);
};

export default SvgCalendar;